/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getbank, syncBanksFromPaystack } from "../../store/bank/bank.action";
import Skeleton from "react-loading-skeleton";
import { colors } from "../../../util/SkeletonColor";
import dayjs from "dayjs";
import Button from "../../extra/Button";
import Table from "../../extra/Table";
import Pagination from "../../extra/Pagination";

const BankSetting = () => {
	const [page, setPage] = useState(0);
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [syncing, setSyncing] = useState(false);

	const [rowsPerPage, setRowsPerPage] = useState(10);

	const dispatch = useDispatch();

	const { bank } = useSelector((state) => state.bank);

	useEffect(() => {
		dispatch(getbank());
	}, [dispatch]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setLoading(false);
		}, 1500); // Adjust the delay time as needed

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		setData(bank ? [...bank].sort((a, b) => (a.name || "").localeCompare(b.name || "")) : []);
	}, [bank]);

	// // pagination
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event, 10));
		setPage(0);
	};

	// Sync from Paystack
	const handleSync = async () => {
		setSyncing(true);
		await dispatch(syncBanksFromPaystack());
		setSyncing(false);
	};

	const mapData = [
		{
			Header: "No",
			width: "20px",
			Cell: ({ index }) => <span className='fw-normal'>{page * rowsPerPage + parseInt(index) + 1}</span>,
		},

		{
			Header: "Bank Name",
			body: "name",
			Cell: ({ row }) => <span className=''>{row?.name}</span>,
		},

		{
			Header: "Bank Code",
			body: "code",
			Cell: ({ row }) => <span className=''>{row?.code || "—"}</span>,
		},

		{
			Header: "Type",
			body: "type",
			Cell: ({ row }) => (
				<span className='' style={{ textTransform: "capitalize" }}>
					{row?.type || "—"}
				</span>
			),
		},

		{
			Header: "Created Date",
			body: "createdAt",
			Cell: ({ row }) => <span className=''>{dayjs(row.createdAt).format("DD MMM YYYY")}</span>,
		},

		// add more columns as needed
	];
	return (
		<>
			<div className='mainSellerTable'>
				<div className='sellerTable'>
					<div className='col-12 headname'>Bank Setting </div>
					<div className='sellerMain'>
						<div className='tableMain mt-2'>
							<div className='sellerHeader primeHeader'>
								<div className='row'>
									<div className='col-10'>
										{bank?.length === 0 && <Button newClass={`whiteFont`} btnColor={`btnBlackPrime`} btnIcon={`fa-solid fa-rotate`} btnName={syncing ? `Syncing...` : `Sync Banks from Paystack`} onClick={handleSync} style={{ borderRadius: "8px", padding: "8px 32px", background: "#e54a13", opacity: syncing ? 0.6 : 1 }} disabled={syncing} />}
										{bank?.length > 0 && (
											<span className='fw-normal' style={{ fontSize: "14px", opacity: 0.7 }}>
												{bank.length} banks loaded from Paystack
											</span>
										)}
									</div>
									<div className='col-2 text-end'></div>
								</div>
							</div>
							<Table data={data} mapData={mapData} PerPage={rowsPerPage} Page={page} type={"client"} />
							<Pagination component='div' count={bank?.length} serverPage={page} type={"client"} onPageChange={handleChangePage} serverPerPage={rowsPerPage} totalData={bank?.length} onRowsPerPageChange={handleChangeRowsPerPage} />
						</div>
					</div>
					<div className='sellerFooter primeFooter'></div>
				</div>
			</div>
		</>
	);
};

export default BankSetting;
